export default __webpack_public_path__ + "static/media/longing2.dca0060b.jpg";